import React from 'react';
import ToolTip from '../../../Shared/ToolTip/ToolTip';
import { PopUpPosition } from '../../../../types';
import styles from './DepositsInformationTooltip.module.scss';
import classNames from 'classnames';

const DepositsInformationTooltip = () => {
  return (
    <ToolTip
      bodyClass={classNames(styles['tooltip-body'])}
      callerText="How do we handle deposits?"
      header="How do we handle deposits?"
      headerClass={classNames(styles['tooltip-header'])}
      maxNoteWidth="400px"
      message={
        <div>
          When you add money to your Retirement Advisory Service account(s),
          those assets will be held in a money market fund until the next
          automatic rebalancing of your accounts occurs to keep your advisory
          accounts aligned with your Recommended Portfolio.
        </div>
      }
      popOutPlacement={PopUpPosition.TOP}
      theme={classNames(styles['tool-tip-trigger'], styles['trigger-text'])}
    />
  );
};

export default DepositsInformationTooltip;
